/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation, ListScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
  uuids?: string[];
}>;

export const DeletePlaylistRelation = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable />} value={option.uuid} />;
  const $uuids = (
    <Variable name="uuids" scalar={<ListScalar isNullable scalar={<UuidScalar isNullable={false} />} />} value={option.uuids} />
  );
  const { query, variables } = render(
    <Mutation operationName="DELETE_PLAYLIST_RELATION">
      <SelectionSet
        name="deleteMetadata_playlist_relation"
        alias="deletePlaylistRelation"
        argument={{
          where: {
            ...(option.uuid && { id: $uuid }),
            id__in: $uuids
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deletePlaylistRelation: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.playlist.request<Data>(query, variables);
};
